import { Message } from 'semantic-ui-react'
import type { BurstStatus } from '../hooks/useBurstStatus'

const formatBurstStartTime = (timestamp: number): string => {
  const date = new Date(timestamp)
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())} UTC on ${pad(date.getUTCDate())}-${pad(date.getUTCMonth() + 1)}-${date.getUTCFullYear()}`
}

interface BurstWarningBannerProps {
  status: BurstStatus
}

/** Renders nothing unless a burst is active and its start time is known. */
function BurstWarningBanner({ status }: BurstWarningBannerProps) {
  if (!status.isActive || !status.startTimestamp) return null

  return (
    <Message warning style={{ marginBottom: '1rem' }}>
      <Message.Header>
        ⚠️ BURST DETECTED! Started at {formatBurstStartTime(status.startTimestamp)}
      </Message.Header>
    </Message>
  )
}

export default BurstWarningBanner
